import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PatientPersonalInfo from './PersonalInfo'
import PatientContactInfo from './ContactInfo'
import AccountHolders from './AccountHolders'
import RelatedPatients from './RelatedPatients'
import RemindersOptToggle from './RemindersOptToggle'
import Reviews from './Reviews'
import css from './patientCard.css'

const isAccountHolderPatient = (accountHolders, patient) =>
  // this is an imperfect check: what if a child is named after the parent?
  // what if subsequent account holders share same name as patient?
  accountHolders.length === 0 ||
  (accountHolders[0].first_name === patient.first_name &&
    accountHolders[0].last_name === patient.last_name)

const PatientCard = ({
  accountHolders,
  location: {
    country_code: countryCode,
    name: locationName,
  },
  hasRemindersTier2,
  hasReviews,
  id,
  loadPatientWithRelations,
  patient,
  relatedPatients,
  pmsType,
  useCorrespondenceValues,
}) => {
  const isOrthoTrac = pmsType.startsWith('OrthoTrac')
  const isDolphin = pmsType === 'Dolphin'
  const isOpenDental = pmsType === 'OpenDental'
  const isCloud9 = pmsType === 'Cloud9'

  return (
    <div className={css.leftPanel}>
      <PatientPersonalInfo patient={patient} />
      {hasReviews && <Reviews id={id} />}
      <div className={css.horizontalLine} />
      <PatientContactInfo
        locationName={locationName}
        patient={patient}
        hasRemindersTier2={hasRemindersTier2}
        id={id}
        loadPatientWithRelations={loadPatientWithRelations}
        countryCode={countryCode}
      />
      {(accountHolders.length > 0 ||
        !isAccountHolderPatient(accountHolders, patient)) && (
        <AccountHolders accountHolders={accountHolders} />
      )}
      {relatedPatients.length > 0 && (
        <RelatedPatients relatedPatients={relatedPatients} />
      )}
      {(isOrthoTrac || isDolphin || isOpenDental || isCloud9) && (
        <RemindersOptToggle
          patient={patient}
          isCloud9={isCloud9}
          useCorrespondenceValues={useCorrespondenceValues}
        />
      )}
    </div>
  )
}

PatientCard.propTypes = {
  accountHolders: PropTypes.arrayOf(PropTypes.object),
  hasRemindersTier2: PropTypes.bool,
  hasReviews: PropTypes.bool,
  id: PropTypes.string,
  loadPatientWithRelations: PropTypes.func,
  location: PropTypes.shape({
    country_code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  patient: PropTypes.object,
  relatedPatients: PropTypes.arrayOf(PropTypes.object),
  pmsType: PropTypes.string,
  useCorrespondenceValues: PropTypes.bool,
}

export default PatientCard



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/index.js